import Frame from './Frame';

// A presentation frame that represents a single slide with 16:9 aspect ratio
class PresentationFrame extends Frame {
  type = 'presentationFrame';

  static defaultWidth() {
    return 1920;
  }

  static defaultHeight() {
    return 1080;
  }

  constructor(options: any) {
    super(options);

    this.width = PresentationFrame.defaultWidth();
    this.height = PresentationFrame.defaultHeight();
    this.scaleX = 1;
    this.scaleY = 1;

    // Disable all resize controls since frame size cannot be changed
    this.controls = {};

    this.lockScalingX = true;
    this.lockScalingY = true;
    this.lockRotation = true;
    this.hasControls = false;
  }
}

export default PresentationFrame;
